/**************************************************
 * Nombre:       Footer
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, IconButton, Typography} from "@mui/material";
import {theme} from "../Tema";
import {ArrowForward} from '@mui/icons-material'
import fondo from '../Recursos/fondo_footer.png'
import {APARTADOS, Constantes, REDES} from "../Constantes";
import logo from '../Recursos/logo.svg'
import {scrolearAComponente} from "../Utilidades/scrolearAComponente";
import {irUrl} from "../Utilidades/irUrl";
import {useResponsive} from "../Modulo_responsive/Hooks/useResponsive";
import {iniciarChatWass} from "../Utilidades/iniciarChatWass";


const Footer = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}}
                  sx={{
                      justifyContent: 'center',
                      backgroundColor: theme.palette.primary.main
                  }}
            >

                <Grid
                    container
                    justifyContent={'center'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{maxWidth: '1400px', px: 3}}
                >

                    <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'center'}
                            size={{xs: 12, sm: 12, md: 12}}
                            sx={{color: '#fff', py: 8}}
                        >

                            <Grid container size={{xs: 12, sm: 8, md: 4}} sx={{justifyContent: 'flex-start'}}>

                                <Grid
                                    container
                                    justifyContent={'flex-start'}
                                    alignItems={'flex-start'}
                                    size={{xs: 12, sm: 12, md: 12}}>

                                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                                          sx={{justifyContent: sCell ? 'center' : 'flex-start'}}>
                                        <Typography sx={{
                                            fontSize: sCell ? 32 : 48,
                                            fontWeight: 800,
                                            fontFamily: 'Raleway',
                                            lineHeight: 1.2
                                        }}>

                                            Reserva ahora
                                        </Typography>
                                    </Grid>


                                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                                          sx={{justifyContent: sCell ? 'center' : 'flex-start'}}>
                                        <Typography
                                            sx={{
                                                fontSize: 16,
                                                fontWeight: 300,
                                                fontFamily: 'Roboto',
                                                color: '#C4C4C4',
                                                textAlign: sCell ? 'center' : 'left'
                                            }}>
                                            Reserva tu experiencia hoy y empieza tu viaje hacia la verdadera paz.
                                        </Typography>
                                    </Grid>

                                </Grid>

                            </Grid>

                            <Grid container size={{xs: 12, sm: 4, md: 8}}
                                  sx={{justifyContent: sCell ? 'center' : 'flex-end', mt: sCell ? 2 : 0}}>
                                <Button
                                    onClick={() => iniciarChatWass({mensaje: 'Hola Magaza, deseo reservar'})}
                                    endIcon={<ArrowForward/>}>
                                    Reservar ahora
                                </Button>
                            </Grid>


                        </Grid>
                    </Grid>

                </Grid>

            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}}
                  sx={{
                      justifyContent: 'flex-start',
                      alignItems: 'flex-start',
                      background: `url(${fondo})`,
                      backgroundSize: 'cover',
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: 'center'
                  }}>

                <Grid
                    container
                    justifyContent={'center'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{maxWidth: '1400px', px: 3, color: '#fff', py: 8}}
                    spacing={1}
                >

                    <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}} spacing={0}>

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 6, md: 3}}>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                <Typography sx={{fontSize: 24, fontWeight: 800, fontFamily: 'Raleway'}}>Link
                                    Rapidos</Typography>
                            </Grid>

                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                sx={{mt: 1.5}}
                            >

                                {APARTADOS.map((it, index) => {
                                    return (
                                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                                              sx={{justifyContent: 'flex-start', mt: 0.5}}>
                                            <Typography
                                                onClick={() => scrolearAComponente(it)}
                                                sx={{
                                                    fontFamily: 'Roboto',
                                                    transition: "all .2s ease-in-out",
                                                    cursor: 'pointer',
                                                    borderBottom: 1,
                                                    borderColor: '#ffffff00',
                                                    '&:hover': {
                                                        borderColor: '#ffffff',
                                                    }
                                                }}
                                            >
                                                {it}
                                            </Typography>
                                        </Grid>
                                    )
                                })}

                            </Grid>

                        </Grid>

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 6, md: 3}}
                            sx={{mt: sCell ? 4 : 0}}
                        >

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                <Typography sx={{fontSize: 24, fontWeight: 800, fontFamily: 'Raleway'}}>
                                    Contactos
                                </Typography>
                            </Grid>

                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                sx={{mt: sCell ? 1.5 : -2.5}}
                            >

                                {Constantes.map((it, index) => {
                                    return (
                                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                                              sx={{justifyContent: 'flex-start', mt: 0.5}}>
                                            <Typography
                                                sx={{
                                                    fontFamily: 'Roboto',
                                                    transition: "all .2s ease-in-out",
                                                    cursor: 'pointer',
                                                    borderBottom: 1,
                                                    borderColor: '#ffffff00',
                                                    '&:hover': {
                                                        borderColor: '#ffffff',
                                                    }
                                                }}
                                            >
                                                {`${it.nombre}: ${it.descripcion}`}
                                            </Typography>
                                        </Grid>
                                    )
                                })}

                            </Grid>

                        </Grid>


                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 6, md: 3}}>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{
                                justifyContent: sCell ? 'center' : 'flex-start', mt: sCell ? 6 :
                                    1
                            }}>
                                <Typography
                                    sx={{
                                        fontSize: 18,
                                        fontWeight: 300,
                                        fontFamily: 'Roboto',
                                        textAlign: sCell ? 'center' : 'right'
                                    }}>
                                    Magaza Lodge es un refugio natural que combina confort y tranquilidad, ofreciendo
                                    experiencias únicas para reconectar con la naturaleza y contigo mismo.
                                </Typography>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                <Grid
                                    container
                                    justifyContent={sCell ? 'center' : 'flex-end'}
                                    alignItems={'flex-start'}
                                    size={{xs: 12, sm: 12, md: 12}}>

                                    {REDES.map((it, index) => {
                                        return (
                                            <Grid container size={{xs: 2, sm: 2, md: 2}}
                                                  sx={{justifyContent: sCell ? 'center' : 'flex-end'}}>
                                                <IconButton
                                                    onClick={() => irUrl(it.url)}
                                                >
                                                    <img src={it.icono} width={40} height={'auto'}/>
                                                </IconButton>
                                            </Grid>
                                        )
                                    })}

                                </Grid>
                            </Grid>


                        </Grid>

                        <Grid
                            container
                            justifyContent={sCell ? 'center' : 'flex-end'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 6, md: 3}}
                            sx={{mt: sCell ? 6 : -2}}
                        >

                            <img
                                src={logo} width={sCell ? '80%' : '90%'} height={'auto'}
                            />


                        </Grid>


                    </Grid>

                </Grid>


            </Grid>


        </Grid>
    )

}
export default Footer

